import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { Computer } from "@mui/icons-material";
import { formatCerberusDate } from "../../model/cerberusModel";

export default function TableCerberus({ logs, totalLogs, onViewDetails }) {
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  useEffect(() => setPage(0), [logs]);
  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden" }}>
      <Box sx={{ p: 2.5 }}>
        <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#234258" }}>
          Fuentes de logs
        </Typography>
        <Typography sx={{ fontSize: 12, color: "#60778b", mt: 0.5 }}>
          {logs.length} de {totalLogs} registros · El estado del registro no confirma una conexión
          de streaming.
        </Typography>
      </Box>
      <TableContainer>
        <Table
          sx={{
            minWidth: 1000,
            "& th": { bgcolor: "#edf3f8", fontWeight: 700, fontSize: 12, color: "#3f5c72" },
            "& td": { fontSize: 13, color: "#29465b", borderColor: "#e9eff4" },
          }}
        >
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              {[
                "ID",
                "Nombre",
                "Host / IP y URL",
                "Estado del registro",
                "Creación · Colombia",
                "Actualización · Colombia",
                "",
              ].map((label) => (
                <TableCell key={label}>{label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.slice(page * size, page * size + size).map((row, index) => (
              <TableRow hover key={`${row.id}-${index}`}>
                <TableCell>#{row.id ?? "—"}</TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Computer sx={{ color: "#5480a1", fontSize: 20 }} />
                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                      {row.name || "Sin nombre"}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography sx={{ fontFamily: "monospace", fontWeight: 600, fontSize: 13 }}>
                    {row.hostname || "Sin host"}
                  </Typography>
                  <Typography
                    sx={{ fontSize: 11, color: "#617a8d", maxWidth: 280, overflowWrap: "anywhere" }}
                  >
                    {row.ip || "Sin URL"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    variant="outlined"
                    label={row.statusText}
                    color={row.statusColor}
                  />
                </TableCell>
                <TableCell>{formatCerberusDate(row.createdAt)}</TableCell>
                <TableCell>{formatCerberusDate(row.updatedAt)}</TableCell>
                <TableCell>
                  <Tooltip
                    title={
                      row.streamUrl
                        ? "Abrir el visor y conectar al stream"
                        : "El registro no contiene una URL HTTP o HTTPS válida"
                    }
                  >
                    <span>
                      <Button
                        size="small"
                        variant="outlined"
                        disabled={!row.streamUrl}
                        onClick={() => onViewDetails(row)}
                        sx={{
                          "&&": { color: "#245e89", borderColor: "#9db7cb" },
                          "&&.Mui-disabled": { color: "#8897a5", borderColor: "#d6e0e8" },
                        }}
                      >
                        Ver logs
                      </Button>
                    </span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
            {!logs.length && (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                  No hay registros que coincidan con los filtros.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={logs.length}
        page={page}
        rowsPerPage={size}
        rowsPerPageOptions={[10, 25, 50]}
        onPageChange={(_, value) => setPage(value)}
        onRowsPerPageChange={(e) => {
          setSize(Number(e.target.value));
          setPage(0);
        }}
        labelRowsPerPage="Registros por página"
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </Paper>
  );
}
TableCerberus.propTypes = {
  logs: PropTypes.array.isRequired,
  totalLogs: PropTypes.number.isRequired,
  onViewDetails: PropTypes.func.isRequired,
};
